import "../../../config/interceptors";
import { userManager } from "../../../services/userService";
import {
  setCredentialsAuth,
  setPermissions,
  setProfile,
  setRepresented,
  setAuthorized,
  setRepresentative,
} from "../auth";
import { endLoading } from "../loading";
import jwtDecode from "jwt-decode";
import {
  getToken,
  isLocalHost,
  isSimulatedAuthenticationEnabled,
} from "../../../config/enviroment";
import {
  clearSimulatedAuthentication,
} from "../../../services/simulatedAuthentication";

export const fetchSignIn = () => {
  if (isSimulatedAuthenticationEnabled() && isLocalHost()) {
    window.location.assign("/acesso-simulado");
    return Promise.resolve();
  }

  return userManager.signinRedirect();
};

export const signOut = () => {
  const authenticated = JSON.parse(getToken());

  if (authenticated?.is_simulated_authentication) {
    clearSimulatedAuthentication();
    return Promise.resolve();
  }

  const decodedToken = jwtDecode(authenticated.access_token);

  if (Date.now() >= decodedToken.exp * 1000) {
    sessionStorage.clear();
    localStorage.clear();
    return true;
  }

  return userManager.signoutRedirect({
    post_logout_redirect_uri: userManager.settings.post_logout_redirect_uri,
  });
};

export const fetchUserSigninCallback = (redirect) => {
  return (dispatch) => {
    userManager
      .signinRedirectCallback()
      .then((response) => {
        const user = jwtDecode(response.access_token);
        dispatch(setCredentialsAuth(response.access_token));
        dispatch(setAuthorized(true));
        dispatch(setPermissions(user.permission));
        dispatch(setProfile(user.profile));
        dispatch( 
          setRepresentative({
            name: user.name_representative,
            documentNumber: user.cpf_cnpj_representative,
          })
        );
        dispatch(
          setRepresented({
            name: user.name_represented,
            documentNumber: user.cpf_cnpj,
            documentType: user.document_type,
          })
        );
        dispatch(endLoading());
        redirect("/");
      })
      .catch(function (e) {
        console.error(e);
        fetchSignIn();
      });
  };
};
